function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import InAppMessage from "./in-app-message.js";

var HtmlMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(HtmlMessage, _InAppMessage);

  var _super = _createSuper(HtmlMessage);

  function HtmlMessage(i, o, e, r, d, t, s, v, n, u, a, c) {
    var _this;

    _classCallCheck(this, HtmlMessage);

    _this = _super.call(this, i, void 0, void 0, o, e, void 0, void 0, void 0, r = r || InAppMessage.DismissType.MANUAL, d, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, t, s, void 0, void 0, void 0, v, void 0, void 0, void 0, n, u, c), _this.messageFields = a, _this.messageFields = a;
    return _this;
  }

  _createClass(HtmlMessage, [{
    key: "Po",
    value: function Po() {
      return !1;
    }
  }, {
    key: "$t",
    value: function $t(i) {
      if (this.uo === InAppMessage.bo.Ur) {
        if (this.So) return !1;
        this.So = !0;
      }

      return this.ti.X(i), !0;
    }
  }, {
    key: "bt",
    value: function bt() {
      var i = _get(_getPrototypeOf(HtmlMessage.prototype), "bt", this).call(this, HtmlMessage.cs);

      return i[InAppMessage.es.Eo] = this.messageFields, i;
    }
  }], [{
    key: "Qr",
    value: function Qr(i) {
      return new HtmlMessage(i[InAppMessage.es.ra], i[InAppMessage.es.qs], i[InAppMessage.es.ta], i[InAppMessage.es.pa], i[InAppMessage.es.ma], i[InAppMessage.es.ja], i[InAppMessage.es.xa], i[InAppMessage.es.wa], i[InAppMessage.es.ka], i[InAppMessage.es.CSS], i[InAppMessage.es.Eo], i[InAppMessage.es.qa]);
    }
  }]);

  return HtmlMessage;
}(InAppMessage);

export { HtmlMessage as default };
HtmlMessage.cs = InAppMessage.bo.Ur;